// Treat clients.name as "missing" when it looks like a bare domain
// (contains a dot and no spaces, e.g. "sandton-locksmith.co.za").
export const isDomainLikeName = (name: string | null | undefined): boolean => {
  if (!name) return true;
  const trimmed = name.trim();
  if (!trimmed) return true;
  return trimmed.includes(".") && !/\s/.test(trimmed);
};

export const needsBusinessName = (name: string | null | undefined): boolean =>
  isDomainLikeName(name);
